import { RouteRecordRaw } from 'vue-router'

import { LayoutGuestSuspense } from '@/pages/suspense'

import { UserRoles } from '@/shared/types/router'

export const useGuestLayout = (routeRecord: RouteRecordRaw): RouteRecordRaw => {
  if (!routeRecord.meta) {
    routeRecord.meta = {}
  }
  routeRecord.meta.layout = LayoutGuestSuspense
  routeRecord.meta.roles = [UserRoles.GUEST]
  return routeRecord
}
